'use strict';

exports.__esModule = true;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var InMemory = exports.InMemory = function () {
  function InMemory() {
    var storage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, InMemory);

    this.storage = storage;
  }

  InMemory.prototype.merge = function merge(key, reduce) {
    var value = reduce(this.storage.hasOwnProperty(key) ? this.storage[key] : null);
    if (value !== null) {
      this.storage[key] = value;
    } else {
      delete this.storage[key];
    }
    return Promise.resolve(value);
  };

  InMemory.prototype.set = function set(key, value) {
    this.storage[key] = value;
    return Promise.resolve();
  };

  InMemory.prototype.get = function get(key) {
    var v = this.storage[key];
    return Promise.resolve(typeof v === 'undefined' ? null : v);
  };

  InMemory.prototype.multiGet = function multiGet(keys) {
    var ret = {};
    for (var _iterator = keys, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
      var _ref;

      if (_isArray) {
        if (_i >= _iterator.length) break;
        _ref = _iterator[_i++];
      } else {
        _i = _iterator.next();
        if (_i.done) break;
        _ref = _i.value;
      }

      var k = _ref;

      ret[k] = this.storage[k];
      if (typeof ret[k] === 'undefined') ret[k] = null;
    }
    return Promise.resolve(ret);
  };

  InMemory.prototype.remove = function remove(key) {
    delete this.storage[key];
    return Promise.resolve();
  };

  InMemory.prototype.keys = function keys() {
    return Promise.resolve(Object.keys(this.storage));
  };

  return InMemory;
}();

var LocalStorage = exports.LocalStorage = function () {
  function LocalStorage() {
    _classCallCheck(this, LocalStorage);
  }

  LocalStorage.prototype.merge = function merge(key, reduce) {
    // $FlowFixMe
    var value = reduce(localStorage.getItem(key));
    if (value !== null) {
      localStorage.setItem(key, value);
    } else {
      localStorage.removeItem(key);
    }
    return Promise.resolve(value);
  };

  LocalStorage.prototype.set = function set(key, value) {
    localStorage.setItem(key, value);
    return Promise.resolve();
  };

  LocalStorage.prototype.get = function get(key) {
    var v = localStorage.getItem(key);
    return Promise.resolve(typeof v === 'undefined' ? null : v);
  };

  LocalStorage.prototype.multiGet = function multiGet(keys) {
    var ret = {};
    for (var _iterator2 = keys, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
      var _ref2;

      if (_isArray2) {
        if (_i2 >= _iterator2.length) break;
        _ref2 = _iterator2[_i2++];
      } else {
        _i2 = _iterator2.next();
        if (_i2.done) break;
        _ref2 = _i2.value;
      }

      var k = _ref2;

      var item = localStorage.getItem(k);
      ret[k] = typeof item === 'undefined' ? null : item;
    }
    return Promise.resolve(ret);
  };

  LocalStorage.prototype.remove = function remove(key) {
    localStorage.removeItem(key);
    return Promise.resolve();
  };

  LocalStorage.prototype.keys = function keys() {
    return Promise.resolve(Object.keys(localStorage));
  };

  return LocalStorage;
}();


//////////////////
// WEBPACK FOOTER
// ./node_modules/@swarm/client/lib/storage.js
// module id = 71
// module chunks = 0